export default "__VITE_ASSET__CG_TrX0o__"